import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getBlogPosts } from '../../api';
import BlogPostCard from '../shared/BlogPostCard';

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getBlogPosts().then(all => setPosts(all.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Latest <span className="text-blue-600">Insights</span></h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Strategies and lessons from building revenue-driving digital products.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map(p => <BlogPostCard key={p.id} post={p} />)}
        </div>
        <div className="text-center mt-12">
          <Link to="/blog" className="text-blue-600 font-medium hover:underline text-lg">
            View all posts &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
}
